import './Control.css';
export var expandButton = '_uoyq2d0-3-15-1';